import React from 'react'
import { Link } from 'react-router-dom'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import PaymentDateScheduleUI from '../../../components/superUser/loanList/PaymentDateScheduleUI'
import DueDateScheduleUI from '../../../components/superUser/loanList/DueDateScheduleUI'
import AllRepaymentNavUI from '../../../components/superUser/loanList/AllRepaymentNavUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SpinnerUI from '../../../widgets/output/SpinnerUI'
import './AllRepaymentListPage.css'

const AllRepaymentSummaryPageUI = ({ context, errorList,
  onRefreshClick,
  onDownloadClick, downloadSubmitted,
  priorPaidLoanRepaymentList, priorPrepaidLoanRepaymentList, totalPaid, priorDueLoanRepaymentList, totalUnpaid
}) =>
  <SuperUserHomePageUI context={context} className='pg_su_rp_lst' topnav='accounts' dimension='w1600'
    centered={!errorList || !totalPaid || !totalUnpaid}
    page='repayments'
  >
    {
      (!errorList || !totalPaid || !totalUnpaid) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    <div>
      {
        totalPaid && totalUnpaid &&
        <>
          <LRTableActionsUI location='top'
            left={
              <span className='g_flex_left g_flex_h'>
                <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
                <IconButtonUI icon='icon-download' onClick={onDownloadClick} label='Download' />
                <SpinnerUI className='g_m_left_25' reserveSpace={true} show={downloadSubmitted} />
                <span className='g_m_left_25 g_large'><b>EMI Tracker</b></span>
              </span>
            }
            right={
              <span>
                <Link to={`/su/overdues/${totalPaid.month == 1 ? totalPaid.year - 1 : totalPaid.year}/${totalPaid.month == 1 ? 12 : totalPaid.month - 1}`}>Previous</Link>
                <span className='g_m_left_100' />
                <Link to={`/su/overdues/${totalPaid.month == 12 ? totalPaid.year + 1 : totalPaid.year}/${totalPaid.month == 12 ? 1 : totalPaid.month + 1}`}>Next</Link>
              </span>
            }
          />
          <div>
            <AllRepaymentNavUI context={context} type='prior' year={totalPaid.year} month={totalPaid.month} />
          </div>
        </>
      }
      {
        totalPaid && totalUnpaid &&
        <PaymentDateScheduleUI
          context={context} totalPaid={totalPaid}
          priorPaidLoanRepaymentList={priorPaidLoanRepaymentList}
          priorPrepaidLoanRepaymentList={priorPrepaidLoanRepaymentList}
        />
      }
      {
        totalPaid && totalUnpaid &&
        <DueDateScheduleUI context={context} totalUnpaid={totalUnpaid} priorDueLoanRepaymentList={priorDueLoanRepaymentList} />
      }
    </div>

  </SuperUserHomePageUI>

export default AllRepaymentSummaryPageUI
